import { render, staticRenderFns } from "./ServerErrorMessage.vue?vue&type=template&id=7b261178&"
import script from "./ServerErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ServerErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports